'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    redirectPath: state.auth.redirectPath
  };
}, authActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (event) {
      event.preventDefault();
      var input = _this.refs.username;
      _this.props.login(input.value);
      input.value = '';
    }, _this.successLogin = function () {
      // this.props.notifSend({
      //   message: "You're logged !",
      //   kind: 'success',
      //   dismissAfter: 2000
      // });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'loginFromToken',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(userId, accessToken) {
        var result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("you' pressed loginFromToken!");
                console.log(accessToken);
                _context.next = 4;
                return this.props.loginFromToken(userId, accessToken);

              case 4:
                result = _context.sent;

                this.successLogin();
                return _context.abrupt('return', result);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loginFromToken(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return loginFromToken;
    }()
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var params = new URLSearchParams(location.search);
      var accessToken = params.get('accessToken');
      var userId = params.get('userId');

      if (!this.props.user && (!accessToken || !userId)) {
        //FOr client only, make this server side
        // window.location.replace(`http://${config.authHost}${window.location.href.split(/[?#]/)[0]}`)
        this.props.redirect(window.location.href.split(/[?#]/)[0]);
      }
      if (userId && accessToken) {
        console.log('do login from token');
        this.loginFromToken(userId, accessToken);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          logout = _props.logout,
          location = _props.location;

      // const params = new URLSearchParams(location.search);
      // const accessToken = params.get('accessToken');
      // const userId = params.get('userId');

      var styles = require('./Login.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        user && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'You are currently logged in as ',
            user.name,
            '.'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn btn-danger', onClick: logout },
              _react2.default.createElement('i', { className: 'fa fa-sign-out' }),
              ' ',
              'Log Out'
            )
          )
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func,
  loginFromToken: _react.PropTypes.func.isRequired,
  redirect: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 1537
// module chunks = 0